import { Button, Col, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { useFilterWatchlistData, useWLTabsContext } from "./hooks";
import { useWatchListContext } from "../../hooks";
import { WatchlistType } from "../types";

import styles from "./styles.less";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons/lib";
import { useRootSelector } from "@/infrastructure/hooks";
import { FireSel } from "@/features/firestore";
import { useWatchListUpdate } from "@/features/applications/hook";

interface IProps {
  tableType: WatchlistType;
}

export default ({ tableType }: IProps) => {
  const exchangeCountryMap = useRootSelector(FireSel.exchangeCountryMap);
  const { userWatchlist, updateWatchlist } = useWatchListUpdate();
  const { unfilteredData, activeKey } = useWatchListContext();
  const { selectedStocks, setSelectedStocks, setAlertModal } = useWLTabsContext();
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [tableType, activeKey, selectedStocks.length]);

  if (activeKey === "all") return null;

  return (
    <Row justify="start">
      <Col sm={24} md={12}>
        <Autocomplete
          className={styles.stockSelect}
          multiple
          options={unfilteredData}
          getOptionLabel={option => `[${option.trading_code}] ${option.trading_name}`}
          value={unfilteredData.filter(e => useFilterWatchlistData(selectedStocks, e.trading_code, e.exchange))}
          filterSelectedOptions
          onChange={(_e, v) => {
            setSelectedStocks(
              v.map(e => ({ ticker: e.trading_code, exchange: e.exchange, country: exchangeCountryMap[e.exchange] }))
            );
          }}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label="Select stocks to add/remove in current watchlist"
              placeholder="Stocks"
            />
          )}
        />
      </Col>
      <Col className={styles.stockAddRemove}>
        {tableType === "watchlist" ? (
          <Button type="primary" size="small" onClick={addToWatchlist} icon={<PlusOutlined />}>
            Add
          </Button>
        ) : (
          <Button type="primary" size="small" onClick={triggerAlertSetting} icon={<SettingOutlined />}>
            Set Limits
          </Button>
        )}
      </Col>
      {error && (
        <Col span={24}>
          <Typography.Text type="danger"> Please select at least one stock.</Typography.Text>
        </Col>
      )}
    </Row>
  );

  function addToWatchlist() {
    if (selectedStocks.length > 0) {
      updateWatchlist({
        ...userWatchlist,
        [activeKey]: [...userWatchlist[activeKey], ...selectedStocks]
      });
      setSelectedStocks([]);
    } else {
      setError(true);
    }
  }

  function triggerAlertSetting() {
    if (selectedStocks.length > 0) {
      setAlertModal(true);
    } else {
      setError(true);
    }
  }
};
